/***
 * Created on 2023/9/1
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import {useEffect, useState} from "react";
import {setLocalUser} from "../service/user";
import {useBoundedStore} from "../lib/store";

export function useProfile() {
    const [profile, setProfile] = useState();
    const [refresh, setRefresh] = useState(new Date().getTime());
    const store = useBoundedStore();

    const getUserProfile = async () => {
        fetch(`/ajax/profile?t=${refresh}`).then(
            resp=> resp.json().then(data =>  {
                if (data.hasOwnProperty('code')) {
                    setProfile(null);
                }
                else {
                    setProfile(data);
                    setLocalUser(data);
                    store.setCurrentUser(data);
                }
            }).catch(error => {
                console.debug(error);
            })
        ).catch(
            reason => {
                console.log(reason);
            }
        )
    }

    const refetech = async () => {
        setRefresh(new Date().getTime());
    }

    useEffect(() => {
        getUserProfile();
    }, [refresh]);

    return {profile, refetech};
}